export class Endpoint {

  static endpoint = [
    {
      domain: 'dev.propertycrm.com.au',
      api: 'https://api.dev.propertycrm.com.au',
      siteName: 'Development'
    },
    {
      domain: 'sydney.propertycrm.com.au',
      api: 'https://api.sydney.propertycrm.com.au',
      siteName: 'Sydney'
    },
    {
      domain: '2020.propertycrm.com.au',
      api: 'https://api.2020.propertycrm.com.au',
      siteName: '2020'
    },
    {
      domain: 'sh2195.propertycrm.com.au',
      api: 'https://api.sh2195.propertycrm.com.au',
      siteName: '2195'
    },
    {
      domain: 'redearth.propertycrm.com.au',
      api: 'https://api.redearth.propertycrm.com.au',
      siteName: 'RedEarth'
    },
    {
      domain: 'delmege.propertycrm.com.au',
      api: 'https://api.delmege.propertycrm.com.au',
      siteName: 'Delmege'
    },
    {
      domain: '2166.propertycrm.com.au',
      api: 'https://api.2166.propertycrm.com.au',
      siteName: '2166'
    },
  ];
}
